import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import { StopPointHelper } from '../../../../helpers/stop-point.helper';
import type { IDeparture } from '../../../../models/departure.model';
import { DepartureOrArrivalApiModelBase } from './departure-or-arrival-base.api-models';
import { ServiceJourneyApiModel } from './service-journey.api-model';

export class DepartureApiModel extends DepartureOrArrivalApiModelBase {
  public static mapToBusinessModel(apiModel: DepartureApiModel): IDeparture {
    return {
      isCancelled: apiModel.isCancelled,
      plannedTime: DateTimeHelper.parse(apiModel.plannedTime),
      stopPointGid: apiModel.realtimeStopPoint?.gid ?? apiModel.stopPoint.gid,
      stopPointName: apiModel.realtimeStopPoint?.name ?? apiModel.stopPoint.name,
      platform: apiModel.realtimeStopPoint?.platform ?? apiModel.stopPoint.platform,
      estimatedTime: apiModel.estimatedTime ? DateTimeHelper.parse(apiModel.estimatedTime) : undefined,
      serviceJourney: ServiceJourneyApiModel.mapToBusinessModel(apiModel.serviceJourney),
      stopPointType: StopPointHelper.mapToStopPointType(apiModel.realtimeStopPoint?.stopPointType ?? apiModel.stopPoint.stopPointType),
    };
  }
}
